import React from "react";
import {change, reducer as formReducer} from "redux-form";
import {combineReducers, createStore} from "redux";
import {Provider} from "react-redux";
import {ContactUsForm, ContactUsFinish} from "../components/BaseForm";
import "../index.css";
import FormHandlers from "../FormHandlers";
import "./index.css";
import {ContactUsDetails, } from "../components/YourDetails";
import oneSvg from "../images/1.svg"
import {ContactUsValidator} from "../util/Validators";
import {ContactUsDirectCall} from "../components/DTMDirectCalls";

const rootReducer = combineReducers({
    form: formReducer,
});

const store = createStore(
    rootReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

const SUBMISSION_URL = process.env.REACT_APP_CU_URL;


function App(props) {
    const {brand, formName, config} = props;
    const handlers = FormHandlers(SUBMISSION_URL, brand , config, {
        onSubmitSuccess: async function (results, dispatch, props) {
            const {formValues} = results;
            if (formValues) {
                const {postcode, digitalData } = formValues;
                ContactUsDirectCall(brand, config, true).complete(postcode , digitalData , window);
            }
            dispatch(change(formName, 'completed', true));
            dispatch(change(formName, 'response', results));
        }
    });


    return (
        <Provider store={store}>
            <div className={`${brand.value} container-fluid`}>
                <ContactUsForm formName={formName || "fca-cu"} loader={props.loader}
                         componentWillMountCallback={async (p) => {
                            return {}
                         }}
                         optionalConfig={{
                             validate: (values) => {
                                 return ContactUsValidator(values);
                             },
                             initialValues: {
                                 brand: brand,
                                 'firstname': "",
                                 'lastname': "",
                                 'postcode': '',
                                 'email': '',
                                 'phone': '',
                                 'privacy': true,
                                 'owner' : '',
                                 'completed': false,
                                 'brandConfig': config,
                                 'eVar39': '',
                                 'GACLIENTID': '',
                             }
                         }}
                         isFormValid={(props) => {
                             const {formValues} = props;
                             if (formValues !== undefined) {
                                 const {firstname, lastname, email, postcode, phone, privacy , owner, vin } = formValues;
                                 return formValues !== undefined && [firstname, lastname, email, postcode, phone , owner ].every((i) => i !== undefined && i.trim().length > 0) && privacy && (owner == "no" || vin)
                             } else {
                                 return false;
                             }
                         }}

                         onSubmit={handlers.onSubmit}
                         onSubmitFail={handlers.onSubmitFail}
                         onSubmitSuccess={handlers.onSubmitSuccess}>

                    <ContactUsDetails formName={formName} icon={oneSvg}/>

                </ContactUsForm>


                <ContactUsFinish formName={formName} config={config} brand={brand} data={"response"}/>

            </div>
        </Provider>
    )
}


export default App;
